import script from "./ResultadosViewPDF.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultadosViewPDF.vue?vue&type=script&setup=true&lang=js"

import "./ResultadosViewPDF.vue?vue&type=style&index=0&id=6dd3549d&lang=css"

const __exports__ = script;

export default __exports__